export const REPORTS_ROUTE = "/{service_company_slug}/reports/"
